<template>
  <div class="filter-box">
    <div class="key-node my">
      <label class="styled-cb">
        <span class="filter-name">Is present</span>
        <input id="users-are-online" type="checkbox" :disabled="isAvailableForCall" v-model="isOnline" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="key-node my">
      <label class="styled-cb">
        <span class="filter-name">Has video</span>
        <input id="users-have-video" type="checkbox" v-model="isAvailableForCall" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div v-if="isAdmin || isCurrentUserDomainAdmin" class="key-node my">
      <label class="styled-cb">
        <span class="filter-name">Is banned</span>
        <input id="users-have-video" type="checkbox" v-model="isBanned" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div v-if="showRoomsFilter && !isSingleRoom" class="key-node room-filter">
      <room-list-check-filter v-model="byRoom"></room-list-check-filter>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RoomListCheckFilter from "../components/RoomListCheckFilter.vue";
export default {
  name: "PersonListFilter",
  components: {
    RoomListCheckFilter
  },
  props: {
    type: Object,
    value: {
      default() {
        return {
          isOnline: false,
          isAvailableForCall: false,
          isBanned: false,
          byRoom: []
        };
      }
    },
    showRoomsFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("users", ["isAdmin", "isCurrentUserDomainAdmin"]),
    ...mapGetters({
      isSingleRoom: "room/isSingleRoom"
    }),
    isOnline: {
      get() {
        return this.value.isOnline || this.value.isAvailableForCall;
      },
      set(value) {
        this.$emit("input", Object.assign(this.value, { isOnline: value }));
      }
    },
    isAvailableForCall: {
      get() {
        return this.value.isAvailableForCall;
      },
      set(value) {
        this.$emit("input", Object.assign(this.value, { isAvailableForCall: value }));
      }
    },
    isBanned: {
      get() {
        return this.value.isBanned;
      },
      set(value) {
        this.$emit("input", Object.assign(this.value, { isBanned: value }));
      }
    },
    byRoom: {
      get() {
        return this.value.byRoom;
      },
      set(value) {
        this.$emit("input", Object.assign(this.value, { byRoom: value }));
      }
    }
  }
};
</script>
